import { Injectable, Injector } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { environment as env } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EnviromentServices {

    constructor(
        private injector: Injector,
        public platformLocation: PlatformLocation) { }

    getEnv() {
        /**  Identify current url */
        const currentURL = (this.platformLocation as any).location.origin;
        /** set envronment default dev */

        console.log(currentURL)

        let envs = { authURL: 'https://auth.parco.com.cy', app_apiURL: 'https://auth.parco.com.cy', prj_apiURL: 'https://api.parco.com.cy', mode: 'default' };

        // if (currentURL?.toLowerCase().indexOf('http://localhost') > -1) {
        //     envs.authURL = 'https://api-accidentcare.rescueline.com.cy/v2/Auth_services.asmx',
        //     envs.apiURL = 'https://api-accidentcare.rescueline.com.cy/v2/WebService.asmx',
        //     envs.mode = 'dev';
        // }
        // const _ePOS = (location.origin.indexOf('epos.app.cspcom.com') > -1 ? true : false) || env.DevelopProject === 'ePOS';
        // if (currentURL?.toLowerCase().indexOf('http://localhost') > -1 || env.DevelopProject === 'ePOS'; ) {

        //     envs.authURL = 'https://auth.parco.com.cy/accidentcare',
        //         envs.prj_apiURL = 'https://auth.parco.com.cy/accidentcare/WebService.asmx',
        //         envs.app_apiURL = 'https://auth.parco.com.cy/accidentcare/WebService.asmx',
        //         envs.mode = 'RescueLine APP';
        //     // envs.authURL = 'https://auth.parco.com.cy',
        //     //     envs.app_apiURL = 'http://localhost:5151',
        //     //     envs.prj_apiURL = 'http://localhost:5151',
        //     //     envs.mode = 'dev';
        // }

        if (currentURL?.toLowerCase().indexOf('epos.app.cspcom.com') > -1 || env.DevelopProject === 'ePOS') {
            envs.authURL = 'https://auth.parco.com.cy',
                envs.app_apiURL = 'https://auth.parco.com.cy',
                envs.prj_apiURL = 'https://api.parco.com.cy',
                envs.mode = 'ePOS APP';
        }

        if (currentURL?.toLowerCase().indexOf('accidentcare.rescueline.com.cy') > -1 || env.DevelopProject === 'RescueLine') {
                envs.authURL = 'https://auth.parco.com.cy/accidentcare',
                envs.prj_apiURL = 'https://auth.parco.com.cy/accidentcare/WebService.asmx',
                envs.app_apiURL = 'https://auth.parco.com.cy/accidentcare/WebService.asmx',
                envs.mode = 'RescueLine APP';
        }

        if (currentURL?.toLowerCase().indexOf('cpp.app.cspcom.com') > -1 || env.DevelopProject === 'CPP') {
            envs.authURL = 'https://auth.parco.com.cy',
                envs.app_apiURL = 'https://auth.parco.com.cy',
                envs.prj_apiURL = 'https://api.parco.com.cy',
                envs.mode = 'CPP APP';
        }

        if (currentURL?.toLowerCase().indexOf('app.appadvisory.eu') > -1 || env.DevelopProject === 'AppAuditors') {
            envs.authURL = 'https://auth.parco.com.cy',
                envs.app_apiURL = 'https://auth.parco.com.cy',
                envs.prj_apiURL = 'https://api.parco.com.cy',
                envs.mode = 'AppAuditors';
        }

        if (currentURL?.toLowerCase().indexOf('registration.appadvisory.eu') > -1) {
            envs.authURL = 'https://auth.parco.com.cy',
                envs.app_apiURL = 'https://auth.parco.com.cy',
                envs.prj_apiURL = 'https://api.parco.com.cy',
                envs.mode = 'AppAuditorsRegistration';
        }


        return envs;
    }


}